import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { css } from "styled-components";

checkoutReviewAndSubmitHeaderStyles.gridItem = {
    width: 12,
    css: css`
        word-break: initial;
    `,
};
